import PageLayout from "components/layout/PageLayout";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetCompanyAiLogQuery } from "./aiLogApiSlice";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import AvatarMini from "components/commons/AvatarMini";
import FormatDate from "utility/FormatDateHour";
import { msToHMS } from "utility/DurationUtility";
import { Dialog } from "primereact/dialog";
import { parseMarkdown } from "../agent/utility";


export default function AiLog({ }) {

    const [t] = useTranslation(["global", "ai"])
    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(25); // Page size dinamico

    const { data: chatLog, isFetching, isError, error, refetch } = useGetCompanyAiLogQuery({
        pageNumber,
        pageSize,
    });

    const timestampTemplate = (record) => (
        <FormatDate timestamp={record.requestedAt * 1000} />
    )
    const responseCodeTemplate = (record) => {
        const code = record.responseCode;
        const badgeClass = code >= 500 ? 'badge rounded-pill bg-danger'
            : code >= 400 ? 'badge rounded-pill bg-warning'
                : code >= 200 && code < 300 ? 'badge rounded-pill bg-success'
                    : 'badge rounded-pill bg-secondary';

        return <span className={badgeClass}>{code}</span>;
    }

    const userTemplate = (record) => {
        return <AvatarMini displayName={record.user.displayName} guid={record.user.guid} />
    }

    const modelAndTempTemplate = (record) => {
        return <div>
            {record.model}<br />
            <small className="text-muted">t: {record.temp}</small>
        </div>
    }

    const durationTemplate = (record) => {
        return msToHMS(record.durationMillis)
    }

    const promptAndResponseTemplate = (record) => {
        return record.prompt ? <PromptAndResponseTemplate data={record} /> : "-"
    }


    const feedbackTemplate = (record) => {
        const feedback = record.feedback;
        let badgeClass, text;

        switch (feedback) {
            case 'GOOD':
                badgeClass = 'badge rounded-pill bg-success';
                text = 'Good';
                break;
            case 'BAD':
                badgeClass = 'badge rounded-pill bg-danger';
                text = 'Bad';
                break;
            case 'NONE':
                badgeClass = 'badge rounded-pill bg-secondary';
                text = '-';
                break;
            default:
                badgeClass = 'badge rounded-pill bg-secondary';
                text = feedback;
        }

        return <span className={badgeClass}>{text}</span>;
    }

    const tokenTemplate = (record) => {
        const tokens = record.token;
        const formatted = tokens >= 1000
            ? (tokens / 1000).toFixed(1) + 'k'
            : tokens;

        const badgeClass = tokens >= 10000 ? 'text-danger'
            : tokens >= 5000 ? 'text-warning'
                : 'text-success';

        return <span className={badgeClass}>{formatted}</span>;
    }

    const content = (

        chatLog &&
        <DataTable
            dataKey="guid"
            value={chatLog.content}
            stripedRows
            paginator
            lazy
            rowsPerPageOptions={[5, 10, 25, 50]}
            rows={pageSize}
            totalRecords={chatLog.totalElements}
            first={pageNumber * pageSize}
            onPage={(e) => {
                setPageNumber(e.page);
                setPageSize(e.rows);
            }}
        >
            <Column field="requestedAt" header={t("property.submited")} body={timestampTemplate}></Column>
            <Column field="responseCode" header={t("property.status")} body={responseCodeTemplate}></Column>
            <Column field="model" header="Model" body={modelAndTempTemplate}></Column>
            <Column field="prompt" header="Chat" body={promptAndResponseTemplate}></Column>
            <Column field="token" header="Token" body={tokenTemplate}></Column>
            <Column field="durationMillis" header={t("property.duration")} body={durationTemplate}></Column>
            <Column field="user" header={t("entity.user")} body={userTemplate}></Column>
            <Column field="feedback" header="Feedback" body={feedbackTemplate}></Column>
        </DataTable>
    )

    return (
        <PageLayout
            pageTitle={t("ai:menu.ai_log")}
            onPageRefresh={refetch}
            isLoadingContent={isFetching}
            bodyContent={content}
        />
    )
}


const PromptAndResponseTemplate = ({ data }) => {
    const [t] = useTranslation(["global", "ai"]);
    const [openDialog, setOpenDialog] = useState(false);
    return (
        <>
            <button className="btn btn-primary m-1" onClick={() => setOpenDialog(true)}>
                <i className="fa-solid fa-comments"></i> Chat
            </button>
            <Dialog
                header={<FormatDate timestamp={data.requestedAt * 1000} />}
                footer={<>{data.token && <>🎟️{data.token}</>} {data.durationMillis && <>⏱️{msToHMS(data.durationMillis)}</>}</>}
                visible={openDialog} onHide={() => setOpenDialog(false)}>
                <h5 className="d-flex justify-content-end align-items-center gap-2">{data.user.displayName}:</h5>
                <div className="d-flex justify-content-end">
                    <div
                        className="bg-primary text-white rounded-3 px-3 py-2"
                        style={{ maxWidth: '75%', wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}
                    >
                        {data.prompt}
                    </div>
                </div>
                <h5 className="text-eh">AI:</h5>
                <div className="d-flex justify-content-start">
                    <div
                        className={`rounded-3 px-3 py-2 bg-black bg-opacity-25`}
                        style={{ maxWidth: '85%', wordBreak: 'break-word' }}
                        dangerouslySetInnerHTML={{
                            __html: parseMarkdown(data.response)
                        }}
                    />
                </div>

            </Dialog >
        </>
    );
};